// src/beta/components/slides/ImageSlide.tsx
import type { V1Slide } from '@/beta/types/story';

interface Props { slide: V1Slide; }

/** Full-bleed image slide. Bottom-left caption (sharp eyebrow + body) when
 *  block.caption is present. Top-left overlay heading + body when the API
 *  attached upstream text blocks. */
export function ImageSlide({ slide }: Props) {
  const src = slide.block.imageMediumUrl ?? slide.block.imageUrl ?? '';
  const caption = slide.block.caption ?? undefined;
  const overlay = slide.overlayTexts[0];

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%', background: '#000' }}>
      {src && (
        <img
          src={src}
          alt={caption ?? 'Story image'}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      )}

      {overlay && (
        <div
          className="vm-fade-up-blur"
          style={{
            position: 'absolute',
            top: 'var(--vm-s-6)',
            left: 'var(--vm-s-6)',
            maxWidth: '50%',
            color: 'var(--vm-warm-white)',
          }}
        >
          {overlay.heading && (
            <h2
              style={{
                fontFamily: 'var(--vm-font-heading)',
                fontSize: 32,
                letterSpacing: '0.04em',
                margin: 0,
              }}
            >
              {overlay.heading}
            </h2>
          )}
          {overlay.bodyText && (
            <p
              style={{
                fontFamily: 'var(--vm-font-body)',
                fontSize: 16,
                lineHeight: 1.6,
                margin: 'var(--vm-s-1) 0 0',
              }}
            >
              {overlay.bodyText}
            </p>
          )}
        </div>
      )}

      {caption && (
        <div
          style={{
            position: 'absolute',
            left: 'var(--vm-s-4)',
            bottom: 'var(--vm-s-4)',
            color: 'var(--vm-warm-white)',
            fontFamily: 'var(--vm-font-heading)',
            fontSize: 11,
            letterSpacing: '0.3em',
            textTransform: 'uppercase',
            background: 'rgba(0,0,0,0.55)',
            padding: '8px 14px',
          }}
        >
          {caption}
        </div>
      )}
    </div>
  );
}
